var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{class:[_vm.className, 'submenu']},[_vm._t("firstItem"),_vm._l((_vm.items),function(item,x){return _c('li',{key:x},[_vm._t("item",null,{"data":{ item: item, x: x }})],2)}),_vm._t("lastItem")],2)}
var staticRenderFns = []

export { render, staticRenderFns }